/**
 * @author NikolaV
 */

import * as React from 'react';
import './FilterSelectionFeedback.scss';
import { IContextMenuItem } from '@shared/ui-react/ContextMenu';
import { mapTools } from '@pages/map/map';
import { Dropdown } from '@shared/ui-react/Dropdown';

export class TreeSelectionFeedback extends React.Component<
    {
        checkedCount: number;
        loadedItemsCount: number;
        totalItemsCount: number;
        onClearSelection: () => void;
        onSelectAll?: () => void;
        countTooltip: string;
        additionalItems?: IContextMenuItem[];
    },
    {}
> {
    render() {
        const { checkedCount, loadedItemsCount, totalItemsCount, onClearSelection, onSelectAll, countTooltip } = this.props;
        const canSelectAll = typeof onSelectAll === 'function';

        if (loadedItemsCount || checkedCount) {
            return (
                <div className='panel-selection-feedback'>
                    <span className='no-break-text' title={countTooltip}>
                        ({loadedItemsCount} / {totalItemsCount})
                    </span>
                    <span className='button' onClick={onClearSelection}>
                        {kuura.getMessage('js_map.clear_selection')}
                    </span>

                    {this.props.additionalItems?.length && (
                        <span className='panel-selection-feedback-more'>
                            <span> | </span>
                            <Dropdown closeOnBodyClick={true} buttonElem='span' buttonStyle={{ cursor: 'pointer', padding: '0 3px' }}>
                                <i className='iconf-caret' />
                                <>
                                    <ul className='dropdown-list clickable'>
                                        {this.props.additionalItems.map(item => (
                                            <li onClick={item.action}>{item.label}</li>
                                        ))}
                                    </ul>
                                </>
                            </Dropdown>
                        </span>
                    )}
                </div>
            );
        }

        return (
            <div className='panel-selection-feedback'>
                <span>{kuura.getMessage('js_map.no_selection')}</span>
                {canSelectAll && (
                    <span className='button js-select-all' onClick={onSelectAll}>
                        {kuura.getMessage('general.select_all')}
                    </span>
                )}
            </div>
        );
    }
}
